// extracted by mini-css-extract-plugin
module.exports = {"colors":"ColorButtons_colors__EsxUR","color":"ColorButtons_color__3K5BX"};